import { render } from "./cavidade.vue?vue&type=template&id=249375ac&scoped=true"
import script from "./cavidade.vue?vue&type=script&lang=js"
export * from "./cavidade.vue?vue&type=script&lang=js"

import "./cavidade.vue?vue&type=style&index=0&id=249375ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249375ac"]])

export default __exports__